import styled from "styled-components";
import { Link } from "react-router-dom";
import { GlobalOutlined, MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  padding: 1.5rem 0.5rem 0.75rem 0.5rem;
  background: linear-gradient(to bottom, #FFD93F, #FFF);

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 1120px) {
    display: block;
  }

  display: none;

  svg {
    fill: #080e34;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 1120px) {
    display: none;
  }
`;

export const MobileDrawerHeader = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 1.5rem;
  margin-bottom: 2.5rem;
  cursor: pointer;
`;

export const MobileDrawerTitle = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: left;
  margin: 0;
  color: #080e34;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: rgb(0, 0, 0);
  transition: color 0.2s ease-in;
  margin-left: clamp(1.5rem, 2.2vw, 2.5rem);

  @media only screen and (max-width: 1120px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #080e34;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #c14f31;
    text-underline-position: under;
    text-decoration: #c14f31 underline;
  }
`;

export const LanguagePickerWrapper = styled("div")`
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: bottom;
  transform: translateY(4px);
  width: 150px;
  height: 40px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(8, 14, 52, 0.12);
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(8, 14, 52, 0.07);
  backdrop-filter: blur(6px);
  transition: all 0.2s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.98);
    border-color: rgba(193, 79, 49, 0.25);
    box-shadow: 0 8px 18px rgba(8, 14, 52, 0.1);
  }

  &::after {
    content: "";
    position: absolute;
    right: 0.8rem;
    width: 0.45rem;
    height: 0.45rem;
    border-right: 2px solid #6b7280;
    border-bottom: 2px solid #6b7280;
    transform: rotate(45deg) translateY(-2px);
    pointer-events: none;
  }

  @media only screen and (max-width: 1120px) {
    width: 150px;
    margin: 0 2rem;
  }
`;

export const LanguageSelect = styled("select")`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0 1.6rem 0 2rem;
  border: 0;
  background: transparent;
  color: #080e34;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
  appearance: none;
  display: flex;
  align-items: center;
`;

export const LanguageIcon = styled(GlobalOutlined)`
  position: absolute;
  left: 0.75rem;
  font-size: 0.9rem;
  color: #080e34;
  z-index: 1;
  pointer-events: none;
`;

export const CoursesNavItem = styled(NavLink)`
  position: relative;
  display: inline-block;
  margin-left: clamp(1.5rem, 2.2vw, 2.5rem);
  font-size: 1.2rem;
  color: rgb(0, 0, 0);
  padding-bottom: 0.5rem;

  @media only screen and (max-width: 1120px) {
    display: none;
  }
`;

export const CoursesNavTrigger = styled("span")`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  .anticon {
    font-size: 0.6em;
  }

  &:hover,
  &:active,
  &:focus {
    color: #c14f31;
    text-underline-position: under;
    text-decoration: #c14f31 underline;
  }
`;

export const CoursesNavTriggerLink = styled(Link)`
  color: inherit;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #c14f31;
    text-underline-position: under;
    text-decoration: #c14f31 underline;
  }
`;

export const CoursesDropdown = styled("div")<{ $open: boolean }>`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  min-width: 240px;
  padding-top: 0.5rem;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
  pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
  transition: opacity 0.15s ease-in-out, visibility 0.15s ease-in-out;
  z-index: 100;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 0.5rem;
  }
`;

export const CoursesDropdownPanel = styled("div")`
  padding: 0.5rem 0;
  background: #fff;
  border: 1px solid rgba(8, 14, 52, 0.12);
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(8, 14, 52, 0.12);
`;

export const CoursesDropdownSection = styled("div")`
  & + & {
    margin-top: 0.35rem;
  }
`;

export const CoursesDropdownSectionLink = styled(Link)`
  display: block;
  margin-bottom: 0.35rem;
  padding: 0.45rem 1.25rem 0.4rem;
  border-bottom: 1px solid rgba(8, 14, 52, 0.1);
  color: #080e34;
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;

  &:hover,
  &:active,
  &:focus {
    color: #c14f31;
    text-decoration: underline;
    text-underline-position: under;
  }
`;

export const CoursesDropdownSectionLabel = styled("div")`
  margin-bottom: 0.35rem;
  padding: 0.45rem 1.25rem 0.4rem;
  border-bottom: 1px solid rgba(8, 14, 52, 0.1);
  color: #080e34;
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
`;

export const CoursesDropdownLink = styled(Link)`
  display: block;
  padding: 0.65rem 1.25rem;
  font-size: 1rem;
  color: #080e34;
  white-space: nowrap;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out;

  &:hover {
    background: rgba(255, 217, 63, 0.35);
    color: #c14f31;
    text-decoration: none;
  }
`;

export const CoursesDropdownAnchor = styled("a")`
  display: block;
  padding: 0.65rem 1.25rem;
  font-size: 1rem;
  color: #080e34;
  white-space: nowrap;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out;

  &:hover {
    background: rgba(255, 217, 63, 0.35);
    color: #c14f31;
    text-decoration: none;
  }
`;

export const CoursesMobileOnly = styled("div")`
  width: 100%;

  @media only screen and (min-width: 1121px) {
    display: none;
  }
`;

export const PracticeMobileOnly = styled(CoursesMobileOnly)``;

export const MobileDrawerMenu = styled("nav")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
  padding: 0 1.5rem 1rem;

  ${CustomNavLinkSmall} {
    display: block;
    width: 100%;
    margin: 0;
    text-align: left;
    padding: 0;
  }

  ${CustomNavLinkSmall}:last-child {
    margin-top: 0.75rem;
  }

  ${LanguagePickerWrapper} {
    margin: 0 auto;
  }

  ${LanguagePickerWrapper} .language-select .ant-select-selection-item {
    text-align: center;
    padding-right: 0 !important;
  }
`;

export const CoursesMobileList = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 0;
`;

export const CoursesMobileTopRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CoursesMobileMainLink = styled(Link)`
  font-size: 1.2rem;
  font-weight: 400;
  color: #080e34;
  line-height: 1.4;
  cursor: pointer;
  text-align: left;
  transition: color 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #c14f31;
    text-decoration: underline;
    text-underline-position: under;
  }
`;

export const CoursesMobileToggle = styled("button")`
  font-size: 1.2rem;
  font-weight: 400;
  color: #080e34;
  line-height: 1.4;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  transition: color 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #c14f31;
    text-decoration: underline;
    text-underline-position: under;
  }
`;

export const CoursesMobileExpandButton = styled("button")`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  background: none;
  color: #080e34;
  cursor: pointer;
  font-size: 0.72rem;
  transition: color 0.2s ease-in-out, transform 0.2s ease-in-out;

  svg {
    transform: rotate(${({ "aria-expanded": expanded }) => (expanded ? "180deg" : "0deg")});
    transition: transform 0.2s ease-in-out;
  }

  &:hover,
  &:active,
  &:focus {
    color: #c14f31;
  }
`;

export const CoursesMobileSubmenu = styled("div")`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0.35rem;
  padding-left: 1rem;
  border-left: 2px solid rgba(8, 14, 52, 0.12);
`;

export const CoursesMobileSectionLabel = styled("div")`
  padding: 0.65rem 0.75rem 0.25rem;
  color: #080e34;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
`;

export const CoursesMobileSectionLink = styled(Link)`
  padding: 0.65rem 0.75rem 0.25rem;
  color: #080e34;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;

  &:hover,
  &:active,
  &:focus {
    color: #c14f31;
    text-decoration: underline;
    text-underline-position: under;
  }
`;

export const CoursesMobileSubLink = styled(Link)`
  display: block;
  width: 100%;
  font-size: 1rem;
  font-weight: 500;
  color: #3d4466;
  padding: 0.6rem 0.75rem;
  margin: 0.15rem 0;
  border-radius: 8px;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #c14f31;
    background: rgba(255, 217, 63, 0.35);
    text-decoration: none;
  }
`;

export const CoursesMobileSubAnchor = styled("a")`
  display: block;
  width: 100%;
  font-size: 1rem;
  font-weight: 500;
  color: #3d4466;
  padding: 0.6rem 0.75rem;
  margin: 0.15rem 0;
  border-radius: 8px;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #c14f31;
    background: rgba(255, 217, 63, 0.35);
    text-decoration: none;
  }
`;
